import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { siteConfig, waLink } from "@/lib/siteConfig";

const navItems = [
  { label: "Layanan", href: "#layanan" },
  { label: "Keunggulan", href: "#keunggulan" },
  { label: "Promo", href: "#promo" },
  { label: "Galeri", href: "#galeri" },
  { label: "FAQ", href: "#faq" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // When at top (over hero), use light text. When scrolled, use foreground.
  const textColor = scrolled ? "text-foreground" : "text-white";
  const mutedColor = scrolled
    ? "text-muted-foreground hover:text-primary"
    : "text-white/80 hover:text-white";

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background/90 backdrop-blur-xl border-b border-border"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          className={`font-heading text-xl md:text-2xl font-bold tracking-tight ${textColor}`}
        >
          <span className="text-[#C97A4E]">●</span> {siteConfig.brandName}
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={`font-body text-sm font-medium transition-colors duration-200 ${mutedColor}`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Button
            asChild
            data-testid="header-cta-whatsapp"
            className="hidden sm:inline-flex rounded-full bg-[#C97A4E] hover:bg-[#B86A3F] text-white font-medium px-5"
          >
            <a href={waLink()} target="_blank" rel="noopener noreferrer">
              Hubungi Kami
            </a>
          </Button>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className={`lg:hidden p-2 rounded-md ${textColor} hover:bg-white/10`}
            aria-label="Buka menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-background border-t border-border"
        >
          <div className="px-6 py-4 flex flex-col gap-4">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="font-body text-base font-medium text-foreground hover:text-primary"
              >
                {item.label}
              </a>
            ))}
            <Button
              asChild
              data-testid="mobile-cta-whatsapp"
              className="mt-2 rounded-full bg-primary hover:bg-primary/90"
            >
              <a href={waLink()} target="_blank" rel="noopener noreferrer">
                Hubungi via WhatsApp
              </a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
